import { createLayerService } from './layers.js';
import { createDrawService } from './draw.js';
import { createIdentifyService } from './identify.js';
import { createProjectionService } from './projections.js';
import { createContextService } from './context.js';
import { createIoService } from './io.js';
import { createStorageService } from './storage.js';
import { initTilePrefetch } from './tile-prefetch.js';

export function createServices({ events, store, ui, map }) {
  const layers = createLayerService({ events, store, ui, map });
  const draw = createDrawService({ events, store, ui, map });
  const identify = createIdentifyService({ events, store, ui, map });
  const projections = createProjectionService({ events, store, ui, map });
  const context = createContextService({ events, projections });
  const io = createIoService({ events, store, ui, map, projections });
  const storage = createStorageService({ events, store, ui });

  initTilePrefetch(map.instance, layers);

  return { layers, draw, identify, projections, context, io, storage };
}
